import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {}

  public setCurrentUser(data: any): void {
    const currentUser: string =
      typeof data === 'object' ? JSON.stringify(data) : data;
    localStorage.setItem('currentUser', currentUser);
  }

  public getCurrentUser(): any {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  public logout(): any {
    localStorage.clear();
  }

  public setUserId(userId: string): void {
    localStorage.setItem('userID', userId);
  }

  public getUserId(): string {
    return localStorage.getItem('userID');
  }

}
